import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { ContributorTerms, TERMS_VERSION } from "../components/ContributorTerms";
import { onboarding as onboardingApi } from "../api/endpoints";
import { useAuth } from "../store/auth";

export function OnboardingTerms() {
  const setContributor = useAuth((state) => state.setContributor);
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleAccept() {
    setSubmitting(true);
    setError(null);
    try {
      const result = await onboardingApi.acceptTerms(TERMS_VERSION);
      setContributor(result.contributor);
      navigate("/onboarding/finish");
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Layout showNav={false} title="Terms">
      <section className="section">
        <div className="wrap narrow">
          <div className="eyebrow">Updated agreement</div>
          <h1 className="display" style={{ fontSize: "clamp(26px,5vw,40px)" }}>
            Terms &<br />Conditions
          </h1>
          <p className="lede" style={{ fontSize: 14 }}>
            We've updated the contributor terms since you joined. Have a read and accept
            them to carry on recording.
          </p>

          <ContributorTerms />

          <label className="check-row accept-row mt-16">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(event) => setAccepted(event.target.checked)}
            />
            <span className="check-box" />
            <span style={{ fontSize: 13 }}>
              I've read and agree to the Inputry Contributor Terms & Conditions, including
              the payment and content guidelines above.
            </span>
          </label>

          {error && <div className="form-error mt-16">{error}</div>}

          <button
            type="button"
            className="btn btn-primary mt-24"
            disabled={!accepted || submitting}
            onClick={handleAccept}
          >
            {submitting ? "Saving…" : "Accept & continue →"}
          </button>
        </div>
      </section>
    </Layout>
  );
}
